import type { SlidesPerViewConfig } from './slides-per-view.type.ts';

export const useSlidesPerView = (totalSlides: number, ...args: SlidesPerViewConfig[]) => {
  const currentConfig = computed(() => {
    return args.find((config) => {
      const { min, max } = config;

      if (min && max) {
        return window.matchMedia(`(min-width: ${min}px) and (max-width: ${max}px)`).matches;
      } else if (min) {
        return window.matchMedia(`(min-width: ${min}px)`).matches;
      } else if (max) {
        return window.matchMedia(`(max-width: ${max}px)`).matches;
      }
    });
  });

  const slidesShowCount = computed(() => {
    const config = currentConfig.value;

    if (!config || !config.slides) {
      return 0;
    }

    const isDynamicSlidesCount = typeof config.slides === 'function';

    // @ts-expect-error: мы тут и так не вызываем числовое значение, потому что строкой выше проверяем это
    return isDynamicSlidesCount ? config.slides(totalSlides) : config.slides;
  });

  return slidesShowCount.value;
};

export type { SlidesPerViewConfig };
